import { render, staticRenderFns } from "./ProductRelationshipList.vue?vue&type=template&id=86303784&scoped=true&"
import script from "./ProductRelationshipList.vue?vue&type=script&lang=js&"
export * from "./ProductRelationshipList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86303784",
  null
  
)

export default component.exports